import React, { useState, useEffect } from 'react';
import { toJS } from 'mobx'
import { observer } from "mobx-react-lite"
import { useNavigate } from "react-router-dom";
import {
	Box, TextField,
	Button, MenuItem,
	InputLabel,
	FormControl,
	Select,
	Typography,
	FormGroup,
	FormControlLabel,
	Switch,
	Grid,
} from '@mui/material';

import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';

import TreeView from '@mui/lab/TreeView';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import TreeItem from '@mui/lab/TreeItem';


import { useDocumentStore } from 'store/RootProvider'
import CommonConst from 'constants/CommonConst';
import * as EzDateUtils from 'utils/EzDateUtils'
import Document from './Document';

/*
 * Module - DocumentList.js
 *
 * Description : 도움말 목록 조회 화면 입니다. 
 *
 * 작성자 : Choi young ho. 
 * Created on Fri Sep 16 2022
 * Copyright (c) 2022 Renewhouse corp
 */
const DocumentList = observer(() => {
	const documentStore = useDocumentStore();

	const [data, setData] = useState(null);
	const [expanded, setExpanded] = React.useState([]);
	const [documentId, setDocumentId] = useState(null);
	/**
	 * 전체 도움말 목록을 
	 * 로딩 합니다. 
	 */
	useEffect(() => {
		doRefreshList();
	}, [])

	useEffect(() => {
		handleExpandClick();
	}, [data]);

	/**
	 * 도움말 
	 * 목록 갱신을 
	 * 스토어에 요청 합니다. 
	 */
	const doRefreshList = async () => {
		try {
			let resultList = await documentStore.doSearch({
				regState: CommonConst.DATA_REG_STATE_NORMAL
			});
			setData(resultList);

		}
		catch (e) {
			console.log("[DocumentList] ", e);
		}
	}

	/**
	 * 도움말 트리
	 * 렌더링 함수 입니다. 
	 * @param {*} nodes 
	 * @returns 
	 */
	const renderTree = (nodes) => {
		return (
			<TreeItem 
				key={nodes.documentId} nodeId={nodes.documentId + ''} label={nodes.documentName}
				onClick={()=>{
					console.log("NOdex....", nodes);
					setDocumentId(nodes.documentId);
				}}
			>
				{Array.isArray(nodes.children)
					? nodes.children.map((node) => renderTree(node))
					: null}
			</TreeItem>
		);
	};

	const handleToggle = (event, nodeIds) => {

		setExpanded(nodeIds);
	};


	const makeExpandList = (lst, result) => {
		if (lst == null) return;
		if (Array.isArray(lst)) {
			lst.map((obj) => {
				if (Array.isArray(obj.children)) {
					result.push(obj.documentId + '');
					obj.children.map((node) => makeExpandList(node, result))
				}
			})
		}
		else {
			result.push(lst.documentId + '');
		}
	}

	const handleExpandClick = () => {
		let lst = [];
		makeExpandList(data, lst);
		setExpanded(lst);
	};

	return (
		<Grid container spacing={0}>
			<Grid item xs={4}>
				{(data != null)
				?
				<div style={{ height: '95vh' }}>
					<TreeView
						aria-label="file system navigator"
						defaultCollapseIcon={<ExpandMoreIcon />}
						defaultExpandIcon={<ChevronRightIcon />}
						expanded={expanded}
						sx={{ height: '90vh', flexGrow: 1, overflowY: 'auto' }}
						onNodeToggle={handleToggle}
					>
						{renderTree(data[0])}
					</TreeView>
				</div>
				:
				<div>
					도움말 로딩 중 .... 
				</div>
				}
			</Grid>
			<Grid item xs={8}>
				<Document 
					documentId={documentId}
				/>
			</Grid>

		</Grid>
	);

});

export default DocumentList;